// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenToolbar_root__3fBcz"};